import React, { useState } from "react";
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./NabiTraining.css";

// --- ASSETS ---
const TRAINING_IMAGES = [
  "/training2.png",
  "/training3.png",
  "/training4.png",
  "/training5.png"
];

export default function NabiTraining() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isHovered, setIsHovered] = useState(false); 
  
  // Form State
  const [formData, setFormData] = useState({
    firstName: "", 
    lastName: "", 
    dob: "", 
    email: "",
    companyName: "", 
    companySize: "", 
    startDate: "", 
    details: ""
  });

  const handleNext = (e) => {
    e.stopPropagation(); // Prevent bubbling issues
    setCurrentSlide((prev) => (prev + 1) % TRAINING_IMAGES.length);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentSlide((prev) => (prev - 1 + TRAINING_IMAGES.length) % TRAINING_IMAGES.length);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "training_requests"), {
        ...formData,
        timestamp: serverTimestamp()
      });
      alert("Request sent successfully! We will contact you soon.");
      setFormData({ firstName: "", lastName: "", dob: "", email: "", companyName: "", companySize: "", startDate: "", details: "" });
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("Error: " + error.message);
    }
    setIsSubmitting(false);
  };

  return (
    <div className="training-container">
      
      {/* --- SECTION 1: NABI FOR COMPANIES --- */}
      <section className="section-white">
        <div className="flex-layout">
          <div className="left-col">
          <h1 className="huge-title">
            <strong>NABI for Companies</strong> &amp; <strong>NABI for Academia</strong>
          </h1>           
          <p className="description">
              Psychological well being and safety isn't just individual: it is a product of environments, relationships, and circumstances.
              <br/><br/>
              Building a holistically safe environment in schools &amp; workplaces can be hard: but Nabi can support you. Explore how creating{" "}
              <strong>psychologically and emotionally safe</strong>{" "}
              environments can be pivotal to fueling growth and productivity.
          </p>
          </div>

          <div className="right-col">
            {[
              {
                num: 1,
                title: "The Need",
                text: (
                  <>
                    Psychological safety is imperative in institutional spaces, like workplaces and schools. It is only through{" "}
                    <strong>psychologically safe</strong> environments that employees &amp; students may express themselves, recognize their wellbeing, and grow: and with them, their institutions.
                  </>
                )
              },
              {
                num: 2,
                title: "To Whom?",
                text: (
                  <>
                    Through <strong>NABI for Companies</strong> &amp; <strong>NABI for Academia</strong>, we aim to highlight the necessity of this safety in a manner that doesn't simply inform, but connect: building intrapersonal relationships and opening paths of communication.
                  </>
                )
              },
              {
                num: 3,
                title: "How?",
                text: (
                  <>
                    With interactive, activity-driven, and engagement-centric presentations and techniques, Nabi's programs look to integrate fundamental psychological safety practices into pre-existing environments.
                  </>
                )
              },
              {
                num: 4,
                title: "The Result",
                text: (
                  <>
                    Participation in the program provides a unique opportunity to increase productivity, engagement, and well-being: creating spaces that flourish, grow, and express themselves to move forward.
                  </>
                )
              }
            ].map((item, index) => (
              <div key={item.num} className={index === 3 ? "info-block info-block-last" : "info-block"}>
                <div className="info-heading-row">
                   <span className="info-num">{item.num}</span> 
                   <div className="vertical-line"></div>
                   <span className="info-title">{item.title}</span>
                </div>
                <p className="info-text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- SECTION 2: CAROUSEL (ORANGE BG) --- */}
      <section className="section-orange">
        <div className="carousel-container">
          
          {/* CAROUSEL CARD WITH HOVER EFFECT */}
          <div 
            className="carousel-card"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
             <img 
               src={TRAINING_IMAGES[currentSlide]} 
               alt={`Training slide ${currentSlide + 1}`} 
               className="card-image-full" 
             />
             
             {/* Arrows: Always visible */}
             <button 
                onClick={handlePrev} 
                className="training-nav-btn training-nav-btn-left"
             >
                ‹
             </button>
             <button 
                onClick={handleNext} 
                className="training-nav-btn training-nav-btn-right"
             >
                ›
             </button>
          </div>

          <div className="carousel-side-text">
             <h2 className="side-heading">A Peek into <br/>Nabi Training: See
             <br/>What's to Come!</h2>
             <p> In schools, Nabi's programs help create safe and supportive environments for students and educators alike: where students have mechanisms to adjust to high-pressure situations and feel supported in their learning journey. In companies, this extends to creating psychologically safe workspaces that support employee well-being and productivity: ensuring workplace dynamics are healthy and safe.</p>
          </div>
        </div>
      </section>

      {/* --- SECTION 4: FORM SECTION --- */}
      <section className="section-form">
         <div className="form-container">
            <div className="blue-box">
              <p className="blue-sub">Explore Nabi's Programs!</p>
               <h1 className="blue-title">Reach<br/>Out!</h1>
               <p className="blue-sub">
               If you want to create healthy and productive spaces, reaching out is the first step!
               </p>
               {/* <div className="white-line"></div> */}
            </div>

            <div className="white-form-box">
               <form onSubmit={handleSubmit} className="form">
                  <div className="form-row">
                     <div className="input-group">
                        <label className="label">First Name</label>
                        <input className="input" placeholder="First Name" value={formData.firstName} onChange={e=>setFormData({...formData, firstName: e.target.value})} />
                     </div>
                     <div className="input-group">
                        <label className="label">Last Name</label>
                        <input className="input" placeholder="Last Name"value={formData.lastName} onChange={e=>setFormData({...formData, lastName: e.target.value})} />
                     </div>
                  </div>

                  <div className="form-row">
                     <div className="input-group">
                        <label className="label">Date of Birth</label>
                        <input type="date" className="input-date" value={formData.dob} onChange={e=>setFormData({...formData, dob: e.target.value})} />
                     </div>
                     <div className="input-group">
                        <label className="label">Email Address *</label>
                        <input type="email" className="input" placeholder="Add Your Email Address" value={formData.email} onChange={e=>setFormData({...formData, email: e.target.value})} required />
                     </div>
                  </div>

                  <div className="form-row">
                     <div className="input-group">
                      <label className="label">Company/School Name *</label>
                      <input className="input" placeholder="Add Your Company/School Name" value={formData.companyName} onChange={e=>setFormData({...formData, companyName: e.target.value})} required />
                     </div>
                     <div className="input-group">
                     <label className="label">Company/School Size *</label>
                     <select className="input" value={formData.companySize} onChange={e=>setFormData({...formData, companySize: e.target.value})}>
                           <option value="">Select</option>
                           <option value="1-50">1-50</option>
                           <option value="51-200">51-200</option>
                           <option value="200+">200+</option>
                        </select>
                     </div>
                  </div>

                  <div className="form-row">
                     <div className="input-group">
                        <label className="label">Potential Start Date *</label>
                        <input type="date" className="input-date" value={formData.startDate} onChange={e=>setFormData({...formData, startDate: e.target.value})} required />
                     </div>
                     <div className="input-group">
                        <label className="label">Additional Details (if any)</label>
                        <input className="input" placeholder="(optional)" value={formData.details} onChange={e=>setFormData({...formData, details: e.target.value})} />
                     </div>
                  </div>

                  <button type="submit" disabled={isSubmitting} className="submit-btn">
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
               </form>
            </div>
         </div>
      </section>

    </div>
  );
}
